<!-- Classes main-div and example-card are catagorized in .css file -->
<div class="login-header">
  <!-- <div class="language-item row">
    <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('vi')"
      [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer" src="./assets/images/vietnam.png"
        alt="vietnamese"></a>
    <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('en')"
      [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer"
        src="./assets/images/united-kingdom.png" alt="english"></a>
  </div> -->
</div>
<div class="login-wrapper">
  <ng-container *ngIf="mode === 'LOGIN'">
    <mat-card class="login-card">
      <form #f="ngForm" (ngSubmit)="isFormValid() && login()" appFocusFirstElement *ngIf="!isRejectLogin">
        <!--logo-->
        <mat-card-header>
          <div mat-card-avatar class="text-center">
            <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
          </div>
        </mat-card-header>

        <!--chọn ngôn ngữ-->
        <div class="text-center txt-select-languages mt-3">
          <!-- <a (click)="onChangeLanguage('vi')">{{'header.vietnamese' | translate}}</a>
          <a class="english_border_right" (click)="onChangeLanguage('en')">{{'header.english' | translate}}</a>
          <br> -->
          <button type="button" class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
            <div>
              <img *ngIf="currentLanguage == 'vi'" class="vt-cursor-pointer" src="../../../../assets/images/vn.svg" alt="vietnamese" width="30" height="20">
              <img *ngIf="currentLanguage == 'en'" class="vt-cursor-pointer" src="../../../../assets/images/en.svg" alt="english" width="30" height="20">
              <img *ngIf="currentLanguage == 'zh'" class="vt-cursor-pointer" src="../../../../assets/images/china.svg" alt="china" width="30" height="20">
              <img *ngIf="currentLanguage == 'es'" class="vt-cursor-pointer" src="../../../../assets/images/es.svg" alt="spanish" width="30" height="20">
            </div>
            <span class="">{{getCurrentNameLanguage()}}</span>
            <div class="">
                <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
                <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
            </div>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
                [ngClass]="{'active-btn': currentLanguage == 'vi'}">
                <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
                {{'Tiếng Việt' | translate}}
            </button>
            <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
                [ngClass]="{'active-btn': currentLanguage == 'en'}">
                <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
                {{'English' | translate}}
            </button>
            <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
                [ngClass]="{'active-btn': currentLanguage == 'zh'}">
                <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
                {{'中国人' | translate}}
            </button>
            <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
                [ngClass]="{'active-btn': currentLanguage == 'es'}">
                <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
                {{'Español' | translate}}
            </button>
          </mat-menu>
        </div>

        <!--text đăng nhập-->
        <div class="vt-text-login-header text-center">{{'login_page.btn_login' | translate}}</div>

        <!--form đăng nhập-->
        <mat-card-content class="pt-2">
          <mat-form-field class="w-100">
            <mat-label class="cls-txt-mat-label">{{'login_page.lbl_username' | translate}}</mat-label>
            <input appAutoFocus matInput type="text" placeholder="{{'login_page.lbl_username' | translate}}"
              name="usname" #usname="ngModel" [(ngModel)]="username" maxlength="200" required id="username"
              (focusout)="username = username ? username.trim() : null">
              <mat-error *ngIf="usname?.errors?.required">
                <span class="text-error">{{'validation.us_required' | translate}}</span>
              </mat-error>
          </mat-form-field>

          <mat-form-field class="w-100">
            <mat-label class="cls-txt-mat-label">{{'login_page.lbl_password' | translate}}</mat-label>
            <input [type]="passwordVisibility ? 'text' : 'password'" matInput placeholder="{{'login_page.lbl_password' | translate}}" name="pass"
              #pass="ngModel" [(ngModel)]="password" ngModel maxlength="100" id="idPassword" required>
              <mat-error *ngIf="pass?.errors?.required">
                <span class="text-error">{{'validation.pass_required' | translate}}</span>
              </mat-error>
              <button matSuffix mat-icon-button color="primary" type="button" (click)="passwordVisibility = !passwordVisibility">
                <mat-icon>{{!passwordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            <mat-error *ngIf="!validUsernameFormat || !validPasswordFormat">
              <span class="text-error">{{'messages.wrong_credential' | translate}}</span>
            </mat-error>
          </mat-form-field>

          <!-- <re-captcha *ngIf="failedLoginCount && failedLoginCount >= limitFailedLoginNoReCaptcha" name="captcha"
            #reCaptcha="ngModel" [(ngModel)]="captcha" required></re-captcha>
          <mat-error *ngIf="showReCaptchaRequiredErr">
            <span class="text-error">{{'validation.captcha_required' | translate}}</span>
          </mat-error> -->
          <app-slide-captcha
          *ngIf="failedLoginCount && failedLoginCount >= limitFailedLoginNoReCaptcha"
          (verifyHandle)="handleCaptcha($event)"
          >

          </app-slide-captcha>

          <!--Lưu đăng nhập-->
          <!-- <mat-checkbox [(ngModel)]="isRemember" [ngModelOptions]="{standalone: true}" color="primary">
            {{'login_page.lbl_rememberme' | translate}}
          </mat-checkbox> -->
        </mat-card-content>

        <!--submit-->
        <mat-card-actions class="mb-0" style="margin: unset;">
          <button mat-raised-button color="primary" type="submit" appTrackEvent="w.btn.dang_nhap"
            class="w-100" style="height: 48px;">{{'login_page.btn_login' | translate}}</button>
        </mat-card-actions>
        <mat-card-actions class="mb-0" style="margin: unset;">
          <button type="button" appTrackEvent="w.btn.dang_nhap_vneid"
            class="w-100 btn-sso-vneid"
            (click)="redirectToVneid()"  
          >
            <img src="./assets/images/sso-login/icon_vneid.svg" alt="" style="margin-right: 8px;">
            <span>{{'login_page.btn_login_sso_vneid' | translate}}</span>
          </button>
        </mat-card-actions>

        <div class="mt-2 mb-2 text-center">
          {{ 'header.or' | translate }}
        </div>

        <mat-card-actions class="mb-0 d-flex justify-content-center" style="margin: unset; gap: 8px;">
          <!--          Đăng nhập bằng Apple-->
          <div class="btn-link" matTooltip="{{ 'linked_account.linked_apple.login_apple' | translate }}">
            <svg (click)="onLogin(LINK_TYPE.APPLE)" id="Group_48905" data-name="Group 48905" xmlns="http://www.w3.org/2000/svg" width="40" height="39.614" viewBox="0 0 40 39.614">
              <ellipse id="Ellipse_2122" data-name="Ellipse 2122" cx="20" cy="19.807" rx="20" ry="19.807" fill="#dadce0" opacity="0.5"/>
              <path id="Path_80849" data-name="Path 80849" d="M6.7-9.644A4.987,4.987,0,0,0,9.914-4.871,14.235,14.235,0,0,1,7.752-.825,4.35,4.35,0,0,1,4.535,1.3,5.784,5.784,0,0,1,2.584.835,6.018,6.018,0,0,0,.475.368,6.228,6.228,0,0,0-1.661.835,5.909,5.909,0,0,1-3.48,1.3,3.4,3.4,0,0,1-5.933.057a11.975,11.975,0,0,1-2.057-2.7A19.52,19.52,0,0,1-9.176-5.182a13.069,13.069,0,0,1-.738-4.2,6.864,6.864,0,0,1,1.819-5.084A6.017,6.017,0,0,1-3.85-16.335a7.5,7.5,0,0,1,2.268.519A8.806,8.806,0,0,0,.211-15.3a3,3,0,0,0,.765-.182q.554-.182,1.134-.415a7.766,7.766,0,0,1,1.345-.389,4.991,4.991,0,0,1,1.4-.1,5.789,5.789,0,0,1,4.482,2.334A4.746,4.746,0,0,0,6.7-9.644ZM3.691-18.2A4.316,4.316,0,0,1,.053-16.387a4.629,4.629,0,0,1,1.318-3.735,5.471,5.471,0,0,1,1.635-1.245,4.814,4.814,0,0,1,1.951-.571A4.969,4.969,0,0,1,3.691-18.2Z" transform="translate(19.914 29.938)" fill="#020a1c"/>
            </svg>
          </div>

          <!--          Đăng nhập bằng Facebook-->
         <div class="btn-link" matTooltip="{{ 'linked_account.linked_facebook.login_facebook' | translate }}">
           <svg (click)="featureInDevelopment()" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path opacity="0.5" d="M20.001 40C31.0467 40 40.001 31.0457 40.001 20C40.001 8.9543 31.0467 0 20.001 0C8.95528 0 0.000976562 8.9543 0.000976562 20C0.000976562 31.0457 8.95528 40 20.001 40Z" fill="#DADCE0"/>
             <path d="M20.001 33.3333C27.3648 33.3333 33.3343 27.3638 33.3343 20C33.3343 12.6362 27.3648 6.66667 20.001 6.66667C12.6372 6.66667 6.66765 12.6362 6.66765 20C6.66765 27.3638 12.6372 33.3333 20.001 33.3333Z" fill="url(#paint0_linear_3_66)"/>
             <path d="M17.661 33.1967V23.2833H14.2576V19.2467H17.661V17.1722C17.661 13.7167 19.7721 11.8389 22.8521 11.8389C23.8912 11.8355 24.9298 11.8885 25.9632 11.9978V15.6089H23.8276C22.1521 15.6089 21.8276 16.4067 21.8276 17.5733V19.24H25.6132L25.091 23.2833H21.8288V33.35C20.4397 33.4987 19.0354 33.4471 17.661 33.1967Z" fill="#F5F6F8"/>
             <defs>
               <linearGradient id="paint0_linear_3_66" x1="20.001" y1="6.66667" x2="20.001" y2="33.3333" gradientUnits="userSpaceOnUse">
                 <stop stop-color="#19AFFF"/>
                 <stop offset="1" stop-color="#0062E0"/>
               </linearGradient>
             </defs>
           </svg>
         </div>
          <!--          Đăng nhập bằng Google-->
            <div class="btn-link" matTooltip="{{ 'linked_account.linked_google.login_google' | translate }}">
              <svg (click)="onLogin(LINK_TYPE.GOOGLE)" version="1.1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#FFC107"/>
                <path d="M3.15302 7.3455L6.43851 9.755C7.32752 7.554 9.48052 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C8.15902 2 4.82802 4.1685 3.15302 7.3455Z" fill="#FF3D00"/>
                <path d="M12 22.0001C14.583 22.0001 16.93 21.0116 18.7045 19.4041L15.6095 16.7851C14.6055 17.5456 13.3575 18.0001 12 18.0001C9.399 18.0001 7.1905 16.3416 6.3585 14.0271L3.0975 16.5396C4.7525 19.7781 8.1135 22.0001 12 22.0001Z" fill="#4CAF50"/>
                <path d="M21.8055 10.0415H21V10H12V14H17.6515C17.2555 15.1185 16.536 16.083 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#1976D2"/>
              </svg>
            </div>
<!--          Đăng nhập bằng Zalo-->
         <div class="btn-link" matTooltip="{{ 'linked_account.linked_zalo.login_zalo' | translate }}">
           <svg (click)="featureInDevelopment()" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
             <g id="Logo_Z" transform="translate(-829 -567)">
               <rect id="Rectangle_23355" data-name="Rectangle 23355" width="40" height="40" transform="translate(829 567)" fill="none"/>
               <g id="Group_49702" data-name="Group 49702" transform="translate(0 50)">
                 <g id="Group_32055" data-name="Group 32055" transform="translate(77.895 -120.105)">
                   <circle id="Ellipse_2122" data-name="Ellipse 2122" cx="18" cy="18" r="18" transform="translate(753.106 639.106)" fill="#dadce0" opacity="0.5"/>
                   <g id="Group_46903" data-name="Group 46903" transform="translate(-195.894 96.139)">
                     <path id="Subtraction_1" data-name="Subtraction 1" d="M12317.568,7718.568H12303a4,4,0,0,1-4-4V7700a4,4,0,0,1,4-4h1.274a11.763,11.763,0,0,0-3.015,7.9c0,.255,0,.43.015.6a11.907,11.907,0,0,0,1.006,4.208,12.827,12.827,0,0,0,1.088,1.936,2.6,2.6,0,0,1,.35.931,3.034,3.034,0,0,1,.047.8,2.447,2.447,0,0,1-.4,1.123c-.018.024-.036.048-.056.072l0,.006-.019.024c-.02.023-.038.048-.057.074a.686.686,0,0,1-.113.122l-.026.024c-.011.008-.02.016-.029.024l-.011.01c-.013.012-.026.023-.04.034l-.034.028c-.023.019-.034.026-.034.04s.036.039.053.046l.009,0a2.811,2.811,0,0,0,.92.153c.08,0,.163,0,.249-.011a2.913,2.913,0,0,0,1.432-.464,2.953,2.953,0,0,0,.313-.229l.006,0a.364.364,0,0,1,.09-.063,11.853,11.853,0,0,0,15.558-1.2V7700a4.028,4.028,0,0,0-1.614-3.215,4.017,4.017,0,0,1,1.617,3.211v14.571A4,4,0,0,1,12317.568,7718.568Z" transform="translate(-11343.285 -7146.317)" fill="#0068ff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
                     <path id="Intersection_1" data-name="Intersection 1" d="M12307.009,7713.391c-.027,0-.176.151-.408.3a2.917,2.917,0,0,1-1.432.464,2.825,2.825,0,0,1-1.169-.142c-.013-.006-.062-.022-.062-.05s.021-.028.067-.068c.028-.021.053-.046.081-.068a.908.908,0,0,0,.139-.146c.047-.065.1-.121.137-.176a2.435,2.435,0,0,0,.4-1.123,3.056,3.056,0,0,0-.046-.8,2.628,2.628,0,0,0-.35-.931,12.677,12.677,0,0,1-1.089-1.936,11.965,11.965,0,0,1-1-4.209c-.013-.2-.016-.4-.016-.6a11.79,11.79,0,0,1,3.019-7.9h13.292a4,4,0,0,1,4,4v12.19a11.85,11.85,0,0,1-15.559,1.2Z" transform="translate(-11344.285 -7146.316)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
                     <path id="Zalo_logo_2019" data-name="Zalo logo 2019" d="M810.417,396.3a2.158,2.158,0,1,0,2.155,2.161A2.156,2.156,0,0,0,810.417,396.3Zm0,3.431a1.27,1.27,0,1,1,1.27-1.27A1.271,1.271,0,0,1,810.417,399.73Zm-3.724-4.61v5.14a.311.311,0,0,0,.316.31h.626V395.12Zm-5.484.846.023-.023a1.076,1.076,0,0,0,.192-.688v-.135h-4.39v.937h3.047l-3.007,3.724a.858.858,0,0,0-.164.559v.237h4.141a.373.373,0,0,0,.372-.378v-.5h-3.194l2.821-3.543C801.09,396.1,801.174,396.006,801.208,395.966Zm3.854.48v.293a2.143,2.143,0,1,0-1.264,3.871,2.114,2.114,0,0,0,1.264-.412.373.373,0,0,0,.378.372h.5v-4.125ZM803.8,399.73h-.006a1.261,1.261,0,1,1,.006,0Z" transform="translate(163.489 160.556)" fill="#0068ff" fill-rule="evenodd"/>
                   </g>
                 </g>
               </g>
             </g>
           </svg>
         </div>
        </mat-card-actions>


        <!--Quên mật khẩu-->
        <div class="text-center forgot-password"><a [routerLink]="['/request-password-reset',id]" appTrackEvent="w.btn.quen_mat_khau"
          class="pull-right text-center">{{'login_page.lnk_forgot_password' | translate}}</a>
        </div>

        <!-- Đăng ký tài khoản -->
        <!-- <div class="text-center forgot-password"><a href="https://sme.viettel.vn/landing-page?alias=VCONTRACT" target="_blank" appTrackEvent="w.btn.dang_ky_tai_khoan"
          class="pull-right text-center">{{'login_page.register_account' | translate}}</a>
        </div> -->
      </form>
      <div *ngIf="isRejectLogin">
         <!--logo-->
         <mat-card-header>
          <div mat-card-avatar class="text-center" style="margin-top: 16px;">
            <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
          </div>
        </mat-card-header>
        <!--chọn ngôn ngữ-->
        <div class="text-center txt-select-languages">
          <a (click)="onChangeLanguage('vi')">{{'header.vietnamese' | translate}}</a>
          <a class="english_border_right" (click)="onChangeLanguage('en')">{{'header.english' | translate}}</a>
          <br>
        </div>
         <!--text Thong bao-->
         <div class="vt-text-login-header text-center">{{'login_page.nofify_reject_login' | translate}}</div>
          <!--text message-->
          <div class="vt-text-login-message text-center">{{'login_page.message_reject_login' | translate}}</div>
      </div>
    </mat-card>
  </ng-container>
  <ng-container *ngIf="mode === 'SEARCH_CLOUD_CA'">
    <app-anonymous-cloud-ca
      (actionBack)="onChangeAction($event)"
    ></app-anonymous-cloud-ca>
 </ng-container>
 <ng-container *ngIf="mode === 'SIGN'">
    <app-anonymous-two-factor-authen
      (confirmSendRequest)="afterVerifyTwoAuthen($event)"
      (changeMode)="changeMode($event)"
    ></app-anonymous-two-factor-authen>
 </ng-container>
</div>

<div class="login-footer">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-12">
        <h5 class="text-white">{{'footer.contact' | translate}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3 text-overflow-ellipsis">
        {{'footer.hot_line' | translate}} {{phoneNumber}}<br>{{'footer.email_detail' | translate}}
      </div>
      <div class="col-5 text-overflow-ellipsis">
        <!-- {{'footer.text_owner' | translate}}<br>{{'footer.paper' | translate}} -->
      </div>
      <div class="col-4 text-right text-overflow-ellipsis">
        {{'footer.copy-right' | translate}}<br>{{'footer.powered' | translate}}
      </div>
    </div>
  </div>
</div>
